export enum HccRxId {
    CMS_RxHCC_V05 = 32,
    CMS_RxHCC_V08 = 33,
    CMS_RxHCC_V08_2025 = 41,
}
